import { LocalFile } from "@/hooks/types";
import { FileToUploadItem } from "./FileToUploadItem";
import { validateVideoFile } from "./utils";

type VideoFilesToUploadProps = {
  localFiles: LocalFile[];
  uploadProgress: Record<string, number>;
  removeFile: (file: LocalFile) => void;
  retryUpload: (fileUrl: string) => void;
};

export const VideoFilesToUpload = ({
  localFiles,
  uploadProgress,
  removeFile,
  retryUpload,
}: VideoFilesToUploadProps) => {
  return (
    <ul className="grid grid-cols-1 gap-x-space125 gap-y-space100 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
      {localFiles.map((localFile, index) => {
        const validationResult = validateVideoFile(localFile.file);
        const filename = localFile.file.name;
        const progress = uploadProgress[localFile.url];
        const warningMessage = !validationResult.isValid
          ? validationResult.message
          : undefined;

        return (
          <FileToUploadItem
            key={`${filename}-${index}`}
            localFile={localFile}
            progress={progress}
            onRemove={() => removeFile(localFile)}
            onRetry={() => retryUpload(localFile.url)}
            isRetrying={localFile.uploadStatus === "uploading"}
            mediaElement={
              <video className="size-full object-cover" src={localFile.url} />
            }
            warningMessage={warningMessage}
          />
        );
      })}
    </ul>
  );
};
